module.exports = __webpack_public_path__ + "img/ingredienten-preirisotto-met-fetakaas.0bd0de7a.jpeg";